








































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import PayrollContributions from "@/employer/components/dashboard/PayrollContributions.vue";
import UpcomingPayroll from "@/employer/components/payroll-dashboard/UpcomingPayroll.vue";
import EmployeeContributionChart from "@/employer/components/dashboard/EmployeeContributionChart.vue";
import ContributionsWidget from "@/employer/components/widgets/ContributionsWidget.vue";
import ContributionsNavigation from "@/employer/components/profile/ContributionsNavigation.vue";
import FicaSavingsWidget from "@/employer/components/widgets/FicaSavingsWidget.vue";
import { FundingOption } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";

@Component ({
  components: {
    PayrollContributions,
    UpcomingPayroll,
    EmployeeContributionChart,
    ContributionsWidget,
    ContributionsNavigation,
    FicaSavingsWidget
  }
})
export default class ContributionDashboard extends Vue {
  userStore = useUserStore();

  get hideContributionsWidgetGraph (): boolean {
      return this.userStore.currentEmployer.fundingOption === FundingOption.ErCalculateBendPull
        || this.userStore.currentEmployer.fundingOption === FundingOption.ErCalculateErPush;
    }
}
